module.exports = __webpack_public_path__ + "img/raw3.2a2fc8bb.png";